var map = {
	"./account-opening-statement/index.vue": [
		"95a9",
		"chunk-0142c61f"
	],
	"./account-type/index.vue": [
		"5ef9",
		"chunk-9becf49a"
	],
	"./bind-card/index.vue": [
		"692f",
		"chunk-bdc9403e",
		"chunk-3e56121a"
	],
	"./captcha/index.vue": [
		"1ca8",
		"chunk-65815204"
	],
	"./confirm/index.vue": [
		"638d",
		"chunk-516b662e"
	],
	"./contact-info/index.vue": [
		"8cea",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-7c61f79e"
	],
	"./financial-info/index.vue": [
		"a1a9",
		"chunk-bdc9403e",
		"chunk-b1cb24ae"
	],
	"./guide/index.vue": [
		"7320",
		"chunk-2d0d6710"
	],
	"./home/components/openAccount.vue": [
		"b5cd",
		"chunk-5b100eac"
	],
	"./home/index.vue": [
		"7abe",
		"chunk-f8b26f08"
	],
	"./id-card-info/index.vue": [
		"25de7",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-0adcce28"
	],
	"./id-card/index.vue": [
		"72a9",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-788d085a"
	],
	"./id-type/index.vue": [
		"ec5e",
		"chunk-12c38cbd"
	],
	"./layout/index.vue": [
		"162e"
	],
	"./other/ components/DataInput.vue": [
		"91c2",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-95aa01de",
		"chunk-04bf56a4"
	],
	"./other/ components/PersonInfo.vue": [
		"db34",
		"chunk-2d0c1919",
		"chunk-95aa01de"
	],
	"./other/index.vue": [
		"bf72",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-95aa01de",
		"chunk-04bf56a4",
		"chunk-29a1096d"
	],
	"./pi-ar/index.vue": [
		"325b",
		"chunk-bdc9403e",
		"chunk-e02e0692"
	],
	"./pi-risk/index.vue": [
		"ca12",
		"chunk-54cb592c"
	],
	"./pi/index.vue": [
		"5fd1",
		"chunk-525e42a0"
	],
	"./reason/index.vue": [
		"d64f",
		"chunk-9abde9de"
	],
	"./risk/index.vue": [
		"d2d7",
		"chunk-7fa08cd9"
	],
	"./signature/index.vue": [
		"1419",
		"chunk-bdc9403e",
		"chunk-47efca4d"
	],
	"./statement/index.vue": [
		"9ef8",
		"chunk-f602dfec"
	],
	"./status/components/ReasonStatus.vue": [
		"8059",
		"chunk-0061b9bf"
	],
	"./status/index.vue": [
		"4a1f",
		"chunk-7b1a4756"
	],
	"./tax-info/components/TaxCard.vue": [
		"4e1f",
		"chunk-646a5290"
	],
	"./tax-info/index.vue": [
		"4ac3",
		"chunk-a675d074"
	],
	"./transfer-pro/index.vue": [
		"442c",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-159cb56b"
	],
	"./transfer-step/index.vue": [
		"f6c4",
		"chunk-30bcfb90"
	],
	"./transfer/components/TransferItem.vue": [
		"c28a",
		"chunk-2d0c1919",
		"chunk-1ace8e68"
	],
	"./transfer/index.vue": [
		"8034",
		"chunk-2d0c1919",
		"chunk-adc7bf5e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ce9f";
module.exports = webpackAsyncContext;